// extracted by mini-css-extract-plugin
module.exports = {"less":"App_less__38JDY"};